import { gql, graphQueryBang } from "shared/lib/graphql"

export const ReorderTQAsMutation = gql`
  mutation ReorderTqas($channel_module_name: String!, $step_type: StepTypeEnum!, $ids: [ID!]!) {
    reorderTqas(input: { channel_module_name: $channel_module_name, step_type: $step_type, ids: $ids }) {
      errors {
        message
      }
    }
  }
`

export function reorderTqasMutation(serviceSlug, stepType, ids) {
  return graphQueryBang(ReorderTQAsMutation, {
    channel_module_name: serviceSlug,
    step_type: stepType,
    ids,
  }).then(response => {
    if (response.reorderTqas?.errors.length > 0) {
      console.error(response.errors)
    }
  })
}
